


































































































































































import { Vue, Component } from 'vue-property-decorator';
import { Popup, Picker, Toast } from 'vant';
import Uploader from '@/components/Uploader.vue';
import openAppTip from '@/plugins/WxOpenAppTip';
import { getDistrict, register } from '../api';

Vue.use(Popup).use(Picker).use(Toast).use(openAppTip);

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate', // for vue-router 2.2+
]);

@Component({
  components: {
    Uploader,
  },
})
export default class Register extends Vue {
  name = '';
  school = '';
  grade = '';
  teacher = '';
  teacherPhone = '';
  base = '';
  title = '';
  intro = '';
  districts = [];
  selectedDistrict = '请选择区域';
  selectedDistrictId = -1;
  showPicker = false;
  isApp = false;
  isLogin = false;

  async created() {
    this.isApp = !!window.udid;
    this.isLogin = !!(window.gettoken() && window.gettoken() !== 'null');
    const ret = await getDistrict();
    this.districts = Object.values(ret.data);
  }

  activated() {
    if (!window.udid) {
      this.$openAppTip();
    }
  }

  checkForm() {
    const mobileReg = /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
    const version = window.version as string;
    const versionNum = Number(version.split('.').join(''));
    if (window.isAndroid && versionNum < 480) {
      Toast('请在上游新闻APP 4.8.0及以上版本报名，即刻更新新版');
      setTimeout(() => {
        location.href =
          'https://imtt.dd.qq.com/16891/apk/807F790A6EC49200FFECA999B8ED2F5D.apk?fsname=com.news.shangyounews_4.8.0_196.apk&csr=1bbd';
      }, 1500);
      return false;
    } else if (!this.name) {
      Toast('请输入姓名');
      return false;
    } else if (!this.school) {
      Toast('请输入学校');
      return false;
    } else if (!this.grade) {
      Toast('请输入班级');
      return false;
    } else if (!this.teacher) {
      Toast('请输入指导老师姓名');
      return false;
    } else if (!this.teacherPhone || !mobileReg.test(this.teacherPhone)) {
      Toast('请填写正确的手机号码');
      return false;
    } else if (!this.base) {
      Toast('请填写研学基地名称');
      return false;
    } else if (!this.title) {
      Toast('请填写作品标题');
      return false;
    } else if (!this.intro) {
      Toast('请填写作品简介');
      return false;
    } else if (this.selectedDistrict === '请选择区域') {
      Toast('请选择区域');
      return false;
    } else {
      return true;
    }
  }

  onConfirm(d: string, i: number) {
    this.selectedDistrict = d;
    this.selectedDistrictId = i + 1;
    this.togglePicker();
  }
  onCancel() {
    this.togglePicker();
  }
  togglePicker() {
    this.showPicker = !this.showPicker;
  }
  onReceiveRemoteUrl(data: any) {
    console.log(data);
  }
  async onSubmit() {
    if (this.checkForm()) {
      const retImage: any = await (this.$refs
        .imageUploader as Uploader).uploadToOss();
      const retVideo: any = await (this.$refs
        .videoUploader as Uploader).uploadToOss();
      const retRegister: any = await register({
        name: this.name,
        school: this.school,
        class: this.grade,
        county_id: this.selectedDistrictId,
        teacher: this.teacher,
        phone: this.teacherPhone,
        base: this.base,
        title: this.title,
        introduction: this.intro,
        cover: retImage[0],
        video: retVideo[0],
      });
      if (retRegister.code === 200) {
        Toast('作品已进入待审核状态，审核通过后将进入参赛作品列表展示');
        setTimeout(() => {
          location.reload();
        }, 1500);
      } else {
        Toast(retRegister.msg);
      }
    }
  }
  login() {
    window.handleMessage('{"action":"mUserLogin","data":""}');
  }
}
